export default __webpack_public_path__ + "static/media/PurpleBackgroundBottomEllipse.7f61dc06.svg";